var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"start-header"},[_c('div',{staticClass:"header-background"},[_c('div',{staticClass:"container"})])])
}]

export { render, staticRenderFns }